export function calcNetChg(close, prevClose) {
  if (close === undefined || close === null) {
    return null;
  }
  if (prevClose === undefined || prevClose === null) {
    return null;
  }
  return (close ?? 0) - (prevClose ?? 0);
}

export function calcNetChgPct(close, prevClose) {
  if (close === undefined || close === null) {
    return null;
  }
  if (prevClose === undefined || prevClose === null || prevClose === 0) {
    return null;
  }

  return (100 * (close - prevClose)) / Math.abs(prevClose);
}

/**
 * Calculates the position of the current price marker within the 52-week range
 *
 * @param {number} currentPrice - The current price
 * @param {number} low52Week - The 52-week low price
 * @param {number} high52Week - The 52-week high price
 * @returns {number} - The position as a percentage (0-100). If the range is low52week or high52week is falsy, defaults to 50 (center).
 */
export function calcPriceMarkerPosition(currentPrice, low52Week, high52Week) {
  // If either boundary is missing, default to center position
  if (!low52Week || !high52Week) {
    return 50;
  }

  // If the range is invalid (high <= low), default to center position
  if (high52Week <= low52Week) {
    return 50;
  }

  // Calculate the position as a percentage within the range
  const position =
    ((currentPrice - low52Week) / (high52Week - low52Week)) * 100;

  // Clamp the position between 0 and 100
  return Math.max(0, Math.min(100, position));
}
